module.exports = __webpack_public_path__ + "img/virtual_bg.23c99433.jpg";